module.exports = __webpack_public_path__ + "img/andriod2.90713fd9.png";